import Swiper from 'swiper/bundle';

$(document).ready(function () {
    onScroll();
    $(document).on("scroll", onScroll);

    //smoothscroll
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");
        $('a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');

        let headerHeight = $('header .fixed-header').outerHeight();
        let elementClick = $(this).attr("href");
        let destination = $(elementClick).offset().top;

        $('html, body').stop().animate({
            scrollTop: destination - headerHeight
        }, 1000, 'swing', function () {
            $(document).on("scroll", onScroll);
        });

    });

    function onScroll(event) {
        const scrollPos = $(document).scrollTop();
        $('#points a').each(function () {
            const currLink = $(this);
            const refElement = $(currLink.attr("href"));
            if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
                $('#points ul li a').removeClass("active");
                currLink.addClass("active");
            } else {
                currLink.removeClass("active");
            }
        });
    }

    // Slider in content
    const buildSwiperSlider = sliderElm => {
        const sliderIdentifier = sliderElm.dataset.id;
        return new Swiper(`#${sliderElm.id}`, {
            spaceBetween: 16,
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: `.image-slider-swiper-button-next-${sliderIdentifier}`,
                prevEl: `.image-slider-swiper-button-prev-${sliderIdentifier}`
            },
            pagination: {
                el: `.swiper-pagination-${sliderIdentifier}`,
                type: "fraction",
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' + '<span class="sep"></span>' + '<span class="' + totalClass + '"></span>';
                }
            },
        });
    }
    const allSliders = $('.simple-image-slider');
    allSliders.each((index, element) => buildSwiperSlider(element));

});

// Slider bottom page
if ($(".agenturglossar-slider.swiper-container").length > 0) {
    const single_agenturglossar_swiper = new Swiper(".agenturglossar-slider.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
    });
}